"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Container.css");
require("../styles/Table.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : Table.js
* Description : Ce fichier contient la définition du composant Table 
*               Ce composant est un tableau sans bordure pour afficher une donnée (label et valeur) en colonne
* Date de création : 23 septembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */

/**
* Table : ce composant est un tableau sans bordure pour afficher une donnée (label et valeur) en colonne
*
* Type : composant 
*
* Parametres : 
*  - labels -- liste des labels à afficher
*  - datas -- liste des données correspondantes aux labels
*/function Table(_ref) {
  var labels = _ref.labels,
    datas = _ref.datas;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "grid-1-1",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: labels.map(function (label, index) {
        return screenWidth > 650 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("h3", {
          className: "table-cell table-label",
          children: [label, " :"]
        }, index) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("h4", {
          className: "table-cell table-label",
          children: [label, " :"]
        }, index);
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: datas.map(function (data, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "table-cell table-data",
          children: data
        }, index);
      })
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
Table.propTypes = {
  labels: _propTypes["default"].array,
  datas: _propTypes["default"].array
};
var _default = exports["default"] = Table;